import { render } from "./ActivationStatusData.vue?vue&type=template&id=2ab28f0a"
import script from "./ActivationStatusData.vue?vue&type=script&lang=js"
export * from "./ActivationStatusData.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__